// Game constants shared between client and server
export const GAME_CONFIG = {
    // Tick rate
    SERVER_TICK_RATE: 20, // 20 ticks per second
    CLIENT_TICK_RATE: 60, // 60 fps target
    // Player
    PLAYER_SPEED: 5, // units per second
    PLAYER_SPRINT_MULTIPLIER: 1.5,
    PLAYER_JUMP_FORCE: 8,
    PLAYER_MAX_HEALTH: 100,
    PLAYER_MAX_MANA: 100,
    // Combat
    ATTACK_RANGE_MELEE: 2,
    ATTACK_RANGE_RANGED: 30,
    ATTACK_COOLDOWN: 1000, // ms
    // World
    CHUNK_SIZE: 32,
    VIEW_DISTANCE: 3, // chunks
    RESPAWN_TIME: 5000, // ms
    // Network
    MAX_PLAYERS_PER_ZONE: 100,
    POSITION_SYNC_RATE: 50, // ms
    INPUT_BUFFER_SIZE: 64,
    // Loot
    LOOT_PICKUP_RANGE: 3,
    LOOT_DESPAWN_TIME: 300000, // 5 minutes
    // Quests
    MAX_ACTIVE_QUESTS: 20,
};
export const CLASS_STATS = {
    warrior: {
        baseHealth: 120,
        baseMana: 40,
        strength: 15,
        agility: 8,
        intelligence: 5,
        stamina: 12,
    },
    mage: {
        baseHealth: 70,
        baseMana: 120,
        strength: 5,
        agility: 8,
        intelligence: 15,
        stamina: 6,
    },
    ranger: {
        baseHealth: 90,
        baseMana: 60,
        strength: 10,
        agility: 15,
        intelligence: 8,
        stamina: 9,
    },
    priest: {
        baseHealth: 80,
        baseMana: 100,
        strength: 5,
        agility: 6,
        intelligence: 12,
        stamina: 8,
    },
};
//# sourceMappingURL=game.js.map